import { displayPercent, formatPoint } from "app/shared/util/percent";
import * as _ from "lodash";

export const columns: any = [
    {
        title: 'Tên đơn vị',
        key: 'ownerName',
        dataIndex: 'ownerName',
    },
    {
        title: 'Lần đánh giá',
        key: 'submittedCount',
        dataIndex: 'submittedCount',
    },
    {
        title: 'Tự đánh giá',
        key: 'submittedStatus',
        dataIndex: 'submittedStatus',
    },
];

export const columnsPreApproval: any = [
    {
        title: 'Lần đánh giá',
        key: 'version',
        dataIndex: 'version',
    },
    {
        title: 'Tự đánh giá',
        key: 'selfEvaluate',
        dataIndex: 'selfEvaluate',
    },
];

export const columnsEvaluation: any = [
    {
        title: 'Mã',
        key: 'itemCode',
        fixed: 'left',
        width: 120,
        dataIndex: 'itemCode',
    },
    {
        title: 'Mục tiêu & KR cả năm',
        fixed: 'left',
        key: 'purposeYear',
        width: 200,
        dataIndex: 'purposeYear',
    },
    {
        title: 'Tỷ trọng',
        key: 'contribution',
        width: 100,
        dataIndex: 'contribution',
        render: item => item ? `${formatPoint(item)}%` : undefined
    },
    {
        title: 'Tự Đánh giá',
        children: [
            {
                title: 'Đã hoàn thành',
                key: 'completeNote',
                width: 200,
                dataIndex: 'completeNote',
            },
            {
                title: 'Lý do (không hoàn thành,tạm dừng,hủy)',
                key: 'unFinishNote',
                width: 200,
                dataIndex: 'unFinishNote',
            },
            {
                title: 'Trạng thái',
                key: 'statusName',
                width: 100,
                dataIndex: 'statusName',
            },
            {
                title: 'Điểm ĐG',
                key: 'ratingPoint',
                width: 80,
                dataIndex: 'ratingPoint',
                render: item => item ? `${formatPoint(item)}%` : undefined
            },
            {
                title: 'Ghi chú',
                key: 'ratingNote',
                width: 150,
                dataIndex: 'ratingNote',
            },
        ]
    },
];

export const plusPoints = [
    {
        criteria: "Thành tích vượt trội/ đóng góp nổi bật trong năm vào thành quả chung của Công ty, Tập đoàn",
    },
    {
        criteria: "Sáng kiến cải tiến giúp nâng cao hiệu quả trong quản lý, vận hành được áp dụng và đem lại hiệu quả vượt bậc được cấp có thẩm quyền của Công ty, Tập đoàn công nhận",
    },
    {
        criteria: "Thành tích khác theo giải trình của đơn vị và đã được cấp có thẩm quyền phê duyệt",
    }
]
export const minusPoints = [
    {
        criteria: "Mắc lỗi làm ảnh hưởng nghiêm trọng tới hoạt động của Công ty",
    },
    {
        criteria: "Các vi phạm nghiêm trọng khác bị cảnh báo, nhắc nhở",
    },
]
